import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Home from './components/Home';
import Members from './components/Members';
import Apply from './components/Apply';
import Gallery from './components/Gallery';
import Bookings from './components/Bookings';
import ContactUs from './components/ContactUs';
import Events from './components/Events';
import Applicants from './components/Applicants';
import AdminLogin from './components/AdminLogin';
import NavBar from './components/NavBar';
import './App.css';

function App() {
  const [isAdmin, setIsAdmin] = useState(false);

  const handleLogin = () => {
    setIsAdmin(true);
  };

  return (
    <Router>
      <div className="app">
        <div className="frame">
          <NavBar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/members" element={<Members />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/events" element={<Events />} />
              <Route path="/apply" element={<Apply />} />
              <Route
                path="/applicants"
                element={isAdmin ? <Applicants /> : <Navigate to="/admin-login" replace />}
              />
              <Route path="/bookings" element={<Bookings />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/admin-login" element={<AdminLogin onLogin={handleLogin} />} />
            </Routes>
          </main>
        </div>
        <footer className="footer">
          &copy; {new Date().getFullYear()} Khayelitsha Youth Choir. All rights reserved.
        </footer>
      </div>
    </Router>
  );
}

export default App;
